import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-url-doc',
  templateUrl: './modal-url-doc.component.html',
  styleUrls: ['./modal-url-doc.component.scss']
})
export class ModalUrlDocComponent implements OnInit {

  form!: UntypedFormGroup;
  url: string = ""
  constructor(
    private readonly dialogRef: MatDialogRef<ModalUrlDocComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly fb: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {
    this.setDataInModal();
    this.initForm();
  }



  setDataInModal() {
    this.url = this.data.url;
  }

  initForm() {
    this.form = this.fb.group({
      URL: ['', [Validators.required]]
    });

    if (this.url !== "") {
      this.form.get('URL')!.setValue(this.url);
    }
  }

  getValue(field: string) {
    return this.form.get(field)!.value;
  }

  closeModal() {
    this.dialogRef.close();
  }
}
